// import React from "react";

// const TimeCell = (props) => {
//   const { date, text } = props.data;

//   console.debug("[TimeCell]");
//   console.debug("date", date);
//   console.debug("text", text);

//   const hours = date.getHours();

//   if (hours == 13 && date.getMinutes() === 0) {
//     return (
//       <div className={"dinner"}>
//         {text}
//         {<div className="cafe" />}
//       </div>
//     );
//   } else if (hours == 14) {
//     return <div className={"dinner"}>{text}</div>;
//   } else {
//     return <div className={null}>{text}</div>;
//   }
// };
// export default TimeCell;

import React from "react";
import Utils from "./utils.js";

const TimeCell = (props) => {
  const { date, text } = props.data;
  const isDinner = Utils.isBetweenLunchTime(date);
  const hasCoffeeCupIcon = Utils.hasCoffeeCupIcon(date);
  return (
    <div className={isDinner ? "dinner" : null}>
      {text}
      {date.getHours() == 13 && date.getMinutes() === 0 && (
        <div className="cafe" />
      )}
    </div>
  );
};
export default TimeCell;
